angular.module('impactx.tax').controller('TaxEventDialogCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$routeParams',
    'TranslationService',
    'ToolbarService',
    '$config',
    TaxEventDialogCtrl
]);

function TaxEventDialogCtrl($scope, dataGen, BackService, ToastService, $routeParams, TranslationService, ToolbarService, $config) {
    var ctrl = this;

    ctrl.getData = function () {
        var paramObj = {
            id: $routeParams.id
        };
        dataGen.getData($scope, paramObj, '/tax/taxevent/view').then(function () {
            defineButtons();
            $scope.$watch(function () {
                return impactX.isDefined($scope, "data.taxRegion.selected.id");
            }, function (newVal, oldVal) {
                if (newVal != oldVal) {
                    $scope.data.taxRate.selected = undefined; // force new selection if region changed
                }
            })
        });
    };

    ctrl.save = function () {
        var paramObj = {
            data: $scope.data
        };
        return dataGen.postAsForm({}, paramObj, '/tax/taxevent/save').then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.delete = function () {
        var paramObj = {
            id: $scope.data.id
        };
        return dataGen.postAsForm({}, paramObj, '/tax/taxevent/delete').then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    ctrl.getData();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                action: ctrl.save,
                type: 'validation',
                params: {form: $scope.dialogData}
            },
            {
                label: TranslationService.get('delete'),
                action: ctrl.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return $scope.data.id > 0;
    }
}